function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function renderInitialDisplayLocation() {
  const zipDisplay = localStorage.getItem('activeZip') || localStorage.getItem('CurrentZipLocation') || '';
  const safeZipDisplay = escapeHtml(zipDisplay);
  const maxDistance = 50; //only matters if it's lower than radius
  const wrapper = document.getElementById('display-locations-wrapper'); //this is the JSON obj coming from shopify
  if (!wrapper) return;

  const rawDisplayLocations = JSON.parse(wrapper.dataset.displayLocations || 'null');
  if (rawDisplayLocations === null) {
    wrapper.innerHTML = '';
    wrapper.style.display = 'none';
    return;
  }
  const displayLocations = rawDisplayLocations;
  const hasAnyOnDisplay = Object.values(displayLocations).some((loc) => loc?.onDisplay === true);
  if (!hasAnyOnDisplay) {
    wrapper.innerHTML = `<div class="store-avail-toggle">
    <svg class="pin-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"/></svg>
    <span class="store-avail-toggle-text">Only Available Online</span></div>`;
    wrapper.style.display = 'none'; // revert this to block to show available online only again.
    return;
  }
  let allStores = [];
  try {
    allStores = JSON.parse(localStorage.getItem('closestStores') || '[]');
  } catch (e) {
    return;
  }

  const onDisplayNearby = allStores.filter(
    (store) => displayLocations[store.locationId]?.onDisplay === true && parseFloat(store.distance) <= maxDistance,
  );
  const storeLabel = onDisplayNearby.length === 1 ? 'Store' : 'Stores';
  const availabilityText =
    onDisplayNearby.length > 0
      ? `On Display At ${onDisplayNearby.length} ${storeLabel} Near ZIP Code <span class="store-avail-zip">${safeZipDisplay}</span>`
      : `No Stores Near ZIP Code <span class="store-avail-zip">${safeZipDisplay}</span> Have This Product On Display`;
  wrapper.classList.toggle('no-results', onDisplayNearby.length === 0);

  wrapper.innerHTML = `
    <button class="store-avail-toggle" aria-expanded="true" aria-controls="store-avail-body">
      <svg class="pin-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"/></svg>
      <span class="store-avail-toggle-text">
        ${availabilityText}
      </span>
      <span class="store-avail-chevron" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>
      </span>
    </button>

    <div id="store-avail-body" class="store-avail-body" role="region" aria-label="Store availability details">
      <form class="store-avail-search" role="search" aria-label="Search stores by ZIP code">
        <label for="store-avail-zip" class="visually-hidden">ZIP Code</label>
        <input required id="store-avail-zip" class="store-avail-input" type="text" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" title="Enter a 5-digit ZIP code" placeholder="ZIP Code" autocomplete="off">
        <button type="submit" class="store-avail-go">Update</button>
      </form>
      <button class="store-avail-locate" aria-label="Use my current location to find nearby stores">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>
        Use my location
      </button>
      <div class="store-avail-status" role="status" aria-live="polite"></div>
      <ul class="display-location-list" role="list" aria-label="Stores with this product on display">
      ${onDisplayNearby
        .map((store) => {
          const name = escapeHtml(store.name || '');
          const distance = escapeHtml(store.distance || '');
          const closetime = escapeHtml(store.closetime || '');
          const visitLink = store.visitLink ? escapeHtml(encodeURI(store.visitLink)) : '#';
          return `
        <li>
          <a href="${visitLink}" class="display-location-item" aria-label="${name}, ${distance}, On Display, Open until ${closetime}">
            <span class="display-dot" aria-hidden="true"></span>
            <div class="display-location-info">
              <span class="display-location-name">${name}
               ${store === onDisplayNearby[0] ? `<span class="display-location-nearest-store">NEAREST</span>` : ''}
              </span>
              <div>
              <span class="display-location-status">On Display</span>
              <span class="display-location-hours">Open until ${closetime}</span></div>
            </div>
            <div class="display-location-distance" aria-hidden="true">${distance}
              <span class="display-location-directions">Directions</span>
            </div>
          </a>
        </li>
      `;
        })
        .join('')}
      </ul>
    </div>
  `;

  // Bind event listeners (instead of inline handlers)
  wrapper.querySelector('.store-avail-toggle').addEventListener('click', toggleAvail);
  wrapper.querySelector('.store-avail-search').addEventListener('submit', function (e) {
    e.preventDefault();
    handleZipSubmit();
  });
  wrapper.querySelector('.store-avail-locate').addEventListener('click', useCurrentLocation);

  wrapper.style.display = 'block';
  wrapper.classList.add('open');
  updateActiveZipVisual();
}
// Render on page load using existing localStorage data
document.addEventListener('DOMContentLoaded', renderInitialDisplayLocation);
// Re-render when filterAndMoveElements (user searches a zip, clicks "Use Current Location", or opens the drawer via "Change store") updates closestStores
document.addEventListener('closestStoresReady', renderInitialDisplayLocation);
// Re-render when a variant/product swap occurs (e.g. color swatch change)
subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
  const newWrapper = data.html.querySelector('#display-locations-wrapper');
  const currentWrapper = document.getElementById('display-locations-wrapper');
  if (newWrapper && currentWrapper) {
    currentWrapper.dataset.displayLocations = newWrapper.dataset.displayLocations;
  }
  renderInitialDisplayLocation();
});

function toggleAvail() {
  const wrapper = document.getElementById('display-locations-wrapper');
  wrapper.classList.toggle('open');
  const toggle = wrapper.querySelector('.store-avail-toggle');
  const body = wrapper.querySelector('#store-avail-body');
  const isOpen = wrapper.classList.contains('open');
  toggle.setAttribute('aria-expanded', isOpen);
  body.inert = !isOpen;
  body.setAttribute('aria-hidden', String(!isOpen));
}

const radius = 50;
const units = 'mile';
//this api key is restricted to our domain only, so it's safe to have it here in the frontend code.
//If we were to use other endpoints or if the key wasn't restricted, we would need to move this to a backend service to keep it secure.
const zipCodeApiKey = 'js-ej58XknjxlVQ2wgbMfONxLuI7o8vJQn3Vs95k8tW2nAMT4CWhD9ryh69v0fGLnel';

async function getNewStores(zipCode) {
  try {
    localStorage.setItem('activeZip', zipCode);
  } catch (e) {}
  const items = document.querySelectorAll('#StoreSelectorListItem_wrapper .StoreSelectorListItem_inn');

  try {
    const response = await fetch(
      `https://www.zipcodeapi.com/rest/${zipCodeApiKey}/radius.json/${zipCode}/${radius}/${units}`,
    );
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const data = await response.json();

    const matchedStores = [];
    data.zip_codes.forEach((zip) => {
      items.forEach((item) => {
        if (item.dataset.pin === zip.zip_code) {
          item.setAttribute('data-distance', zip.distance);
          matchedStores.push(item);
        }
      });
    });

    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const currentDay = dayNames[new Date().getDay()];
    matchedStores.forEach((item) => {
      item.querySelectorAll('.storehoures-info[data-day]').forEach((el) => {
        el.classList.toggle('active', el.getAttribute('data-day') === currentDay);
      });
    });

    updateStoreOpenTime(matchedStores);

    const closestStores = matchedStores
      .sort((a, b) => parseFloat(a.dataset.distance) - parseFloat(b.dataset.distance))
      .map((store) => ({
        locationId: store.dataset.lcid,
        name: store.querySelector('.storename-text')?.textContent || '',
        pin: store.dataset.pin,
        distance: store.dataset.distance + ' mi',
        visitLink: store.querySelector('.button-visit-store')?.getAttribute('href') || '',
        opentime: store.querySelector('.storeopen-time')?.textContent || '',
        closetime: store.querySelector('.storeclose-time')?.textContent || '',
      }));

    try {
      localStorage.setItem('closestStores', JSON.stringify(closestStores));
    } catch (e) {
      // localStorage unavailable or full
    }
    document.dispatchEvent(new Event('closestStoresReady'));
  } catch (error) {
    console.error('Error fetching new stores:', error);
  }
}

function handleZipSubmit() {
  const zipCode = document.querySelector('.store-avail-input').value.trim();
  if (!/^\d{5}$/.test(zipCode)) return;
  getNewStores(zipCode);
}

const useCurrentLocation = () => {
  let currentZipLocation = null;
  try {
    currentZipLocation = localStorage.getItem('CurrentZipLocation');
  } catch (e) {
    // localStorage unavailable
  }
  if (currentZipLocation) {
    getNewStores(currentZipLocation);
  } else {
    const status = document.querySelector('.store-avail-status');
    if (status) status.textContent = 'Unable to retrieve your location. Please enter a ZIP code manually.';
  }
};

//helper to add dynamically active class to the span with the zipcode
const updateActiveZipVisual = () => {
  const spanToModify = document.querySelector('.store-avail-zip');
  if (spanToModify) {
    spanToModify.classList.add('active');
    //runs a coroutine or delay of .5s to remove the active class, so it looks like a flash or highlight effect
    setTimeout(() => {
      spanToModify.classList.remove('active');
    }, 500);
  }
};
